export function motionLabel(file) {
  if (!file || typeof file !== 'string') return '—';
  const base = file.split('/').pop() || file;
  return base.replace(/\.motion3\.json$/i, '');
}

/** @returns {{ motionGroup: string, motionIndex: number, file: string, label: string }[]} */
export function flattenMotions(modelJson) {
  const motions = modelJson?.FileReferences?.Motions;
  if (!motions || typeof motions !== 'object') return [];
  const out = [];
  for (const [group, list] of Object.entries(motions)) {
    if (!Array.isArray(list)) continue;
    list.forEach((entry, motionIndex) => {
      const file = entry?.File || entry?.file;
      if (!file) return;
      out.push({
        motionGroup: group,
        motionIndex,
        file,
        label: motionLabel(file)
      });
    });
  }
  return out;
}
